var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-progress-bar"},[_c('div',{class:_vm.count <= (_vm.maxDuration - 2) ? 'line' : 'line-warning',style:({
        width: (((_vm.count / _vm.maxDuration) * 100) + "%")
      })})])}
var staticRenderFns = []

export { render, staticRenderFns }